import { render, staticRenderFns } from "./ProductInfor.vue?vue&type=template&id=23a8db2e&scoped=true"
import script from "./ProductInfor.vue?vue&type=script&lang=js"
export * from "./ProductInfor.vue?vue&type=script&lang=js"
import style0 from "./ProductInfor.vue?vue&type=style&index=0&id=23a8db2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8db2e",
  null
  
)

export default component.exports